import React from 'react';
import { Route } from 'react-router';
import createCustomRoute from 'hocs/createCustomRoute';
import PaymentMethod from './components/PaymentMethod';
import PaymentConfiguration from './components/PaymentConfiguration';

const PaymentRoutes = createCustomRoute('PaymentRoutes', props => (
  <Route {...props}>
    <Route path="payment_methods" component={PaymentMethod} />
    <Route path="payment_configuration" component={PaymentConfiguration} />
  </Route>
));

export default PaymentRoutes;
